import { defaultMetadataSetState } from "../const";

const metadataSetAction = {
  initializeState: 'INITIALIZE_STATE',
  changeName: 'CHANGE_NAME',
  changeByManualOrImport: 'CHANGE_BY_MANUAL_OR_IMPORT',
  changeUrl: 'CHANGE_URL',
  changeIssuer: 'CHANGE_ISSUER',
  changeCertificate: 'CHANGE_CERTIFICATE',
  changeLogoutUrl: 'CHANGE_LOGOUT_URL',
  changeFingerprint: 'CHANGE_FINGERPINT',
  changeMetadataSetXml: 'CHANGE_METADATASET_XML'
};

const metadataSetReducer = (state, action) => {
  switch (action.type) {
    case metadataSetAction.initializeState:
      return {
        ...state,
        ...action.payload
      }
    case metadataSetAction.changeName:
      return {
        ...state,
        name: action.payload
      };
    case metadataSetAction.changeByManualOrImport:
      return {
        ...state,
        byManualOrImport: action.payload
      };
    case metadataSetAction.changeUrl:
      return {
        ...state,
        url: action.payload
      };
    case metadataSetAction.changeIssuer:
      return {
        ...state,
        issuer: action.payload
      };
    case metadataSetAction.changeCertificate:
      return {
        ...state,
        certificate: action.payload
      };
    case metadataSetAction.changeLogoutUrl:
      return {
        ...state,
        logoutUrl: action.payload
      };
    case metadataSetAction.changeFingerprint:
      return {
        ...state,
        fingerprint: action.payload
      };
    case metadataSetAction.changeMetadataSetXml:
      return {
        ...state,
        metadataSetXml: action.payload
      };
    default:
      return defaultMetadataSetState;
  }
};

export default {
  defaultState: defaultMetadataSetState,
  action: metadataSetAction,
  reducer: metadataSetReducer
}